import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { FormattedMessage, useIntl } from 'react-intl';

import { BoundType } from '../../models/BoundType';
import { MessageState } from '../../models/MessageState';
import { MessageType } from '../../models/MessageType';
import {
	TranslateMessageBoundTypeFilter,
	TranslateMessageStateFilter,
	TranslateMessageTypeFilter,
} from '../../utils/TranslateStates';
import {useLocation} from "react-router";

export function MessageFilterBar({ defaultBoundTypeFilter, onSubmit }) {
	const intl = useIntl();

	const { search } = useLocation();
	const params = new URLSearchParams(search);
	console.log('messageFilter', params);

	const [keywordFilter, setKeywordFilter] = useState(params.get('keyword')!==null && params.get('keyword')!=-'' ? params.get('keyword')  : '');
	const [boundTypeFilter, setBoundTypeFilter] = useState(
		params.get('boundType')!==null  ? params.get('boundType')  : defaultBoundTypeFilter
	);
	const [typeFilter, setTypeFilter] = useState(params.get('type')!==null  ? params.get('type')  : MessageType.INTERNAL);
	const [stateFilter, setStateFilter] = useState(params.get('state')!==null && params.get('state')!=-'1' ? params.get('state')  : '-1');

	function handleSearch() {
		const history = window.history;


		let currentUrlParams = new URLSearchParams(window.location.search);
		if(keywordFilter!== null && keywordFilter!== ''){
			currentUrlParams.set('keyword',keywordFilter);
		}else{
			currentUrlParams.delete('keyword')
		}
		if(boundTypeFilter!== null && boundTypeFilter!== defaultBoundTypeFilter){
			currentUrlParams.set('boundType',boundTypeFilter);
		}else{
			currentUrlParams.delete('boundType')
		}
		if(typeFilter!== null && typeFilter!== MessageType.INTERNAL){
			currentUrlParams.set('type',typeFilter);
		}else{
			currentUrlParams.delete('type')
		}
		if(stateFilter!== null && stateFilter!== '-1'){
			currentUrlParams.set('state',stateFilter);
		}else{
			currentUrlParams.delete('state')
		}

		const url = currentUrlParams.size==0 ? window.location.pathname : window.location.pathname + '?' + currentUrlParams.toString();
		history.replaceState({}, '', url);
	}

	const handleOnClick = (e) => {
		e.preventDefault();
		let typeF = typeFilter === '-1' ? null : typeFilter;
		let boundTypeF = boundTypeFilter === '-1' ? null : boundTypeFilter;
		let stateF = stateFilter === '-1' ? null : stateFilter;

		let filters = {
			keyword: keywordFilter,
			type: typeF,
			boundType: boundTypeF,
			state: stateF,
			parentExternalId: null,
		};

		handleSearch();

		onSubmit(filters, 0);
	};

	return (
		<Row className='searchFilters'>
			<Col md='4'>
				<input
					type='text'
					value={keywordFilter}
					className={'form-control  rounded-0'}
					onChange={(e) => setKeywordFilter(e.target.value)}
					placeholder={intl.formatMessage({
						id: 'messages.keyword',
					})}
				/>
			</Col>

			<Col md='2'>
				<select
					className={'form-control  rounded-0'}
					onChange={(e) => setBoundTypeFilter(e.target.value)}
					value={boundTypeFilter}
				>
					<option value={'-1'}>
						{intl.formatMessage({
							id: 'messages.allToText',
						})}
					</option>
					{BoundType.values().map((boundType) => {
						return (
							<option key={boundType} value={boundType}>
								<TranslateMessageBoundTypeFilter bound={boundType}/>
							</option>
						);
					})}
				</select>
			</Col>

			<Col md='2'>
				<select
					className={'form-control rounded-0'}
					onChange={(e) => setTypeFilter(e.target.value)}
					value={typeFilter}
				>
					<option value={'-1'}>
						{intl.formatMessage({
							id: 'messages.allTypeText',
						})}
					</option>
					{MessageType.values().map((type) => {
						return (
							<option key={type} value={type}>
								{TranslateMessageTypeFilter(type)}
							</option>
						);
					})}
				</select>
			</Col>

			<Col md='2'>
				<select
					className={'form-control rounded-0'}
					onChange={(e) => setStateFilter(e.target.value)}
					value={stateFilter}
				>
					<option value={'-1'}>
						{intl.formatMessage({
							id: 'messages.allStateText',
						})}
					</option>
					{MessageState.values().map((state) => {
						return (
							<option key={state} value={state}>
								{TranslateMessageStateFilter(state)}
							</option>
						);
					})}
				</select>
			</Col>

			<Col md='2'>
				<button
					className={'btn btn-outline-primary'}
					onClick={handleOnClick}
					type='submit'
				>
					<FaSearch className={'mx-0'} /> <FormattedMessage id='all.search' />
				</button>
			</Col>
		</Row>
	);
}
